const defaultTTL = 1 * 60 * 60 * 1000; // 默认1H缓存有效期

export class LocalCache {
  private static instance: LocalCache;
  private ttl = defaultTTL;
  private constructor(ttl = defaultTTL) {
    this.ttl = ttl;
  }

  static getInstance(ttl = defaultTTL) {
    if (!LocalCache.instance) {
      LocalCache.instance = new LocalCache(ttl);
    }
    return LocalCache.instance;
  }

  setLocalData(key: string, value: Object) {
    try {
      localStorage.setItem(
        key,
        JSON.stringify({
          updateTime: Date.now(),
          data: value,
        })
      );
    } catch (e) {
      //
    }
  }

  getLocalData(key: string) {
    try {
      const raw = localStorage.getItem(key);
      const result = JSON.parse(raw || '');
      if (result && Date.now() - result.updateTime <= this.ttl) {
        return result.data;
      }
    } catch (e) {
      //
    }
    return null;
  }
}
